import { useEffect, useState } from 'react'
import { showValidationMessage } from '@/lib/utils/notifications'
import { ResidentDialogShell } from './ResidentDialogShell'
import type { ReasonDialogProps } from '../../types'



export function ReasonDialog({ isOpen, title, onClose, onSubmit }: ReasonDialogProps) {
  const [note, setNote] = useState('')

  useEffect(() => {
    if (isOpen) setNote('')
  }, [isOpen])

  return (
    <ResidentDialogShell
      isOpen={isOpen}
      title={title}
      onClose={onClose}
      panelDataTestId="reason-dialog-panel"
      footer={
        <div
          className="flex flex-col-reverse gap-2 sm:flex-row sm:justify-end"
          data-testid="reason-dialog-footer"
        >
          <button
            type="button"
            onClick={onClose}
            data-testid="reason-dialog-cancel-button"
            className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm font-semibold sm:w-auto"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={() => {
              if (!note.trim()) {
                showValidationMessage('Note is required.')
                return
              }
              // Parent closes the dialog (e.g. confirmApprovalReason → closeDialog).
              // Do not also call onClose() here — that runs cancel/revert and clears the pending decision.
              onSubmit(note)
            }}
            data-testid="reason-dialog-submit-button"
            className="w-full rounded-lg bg-button px-3 py-2 text-sm font-semibold text-white sm:w-auto"
          >
            Submit
          </button>
        </div>
      }
    >
      {/* Angular reason.component.html: label "Description" when fromPage==='backup' else "Reason",
          maxlength 1000 with a live remaining-char counter. No 'backup' source is wired into this
          React dialog (only COVID reason uses it), so the label defaults to "Reason". */}
      <label className="mb-1 block text-sm font-medium text-slate-700" htmlFor="reason-dialog-textarea">
        Reason{' '}
        <span className="font-normal text-slate-400">({1000 - note.length} char)</span>
      </label>
      <textarea
        id="reason-dialog-textarea"
        className="min-h-28 w-full rounded-lg border border-slate-200 px-3 py-2"
        value={note}
        maxLength={1000}
        onChange={(e) => setNote(e.target.value)}
        placeholder="Note"
        data-testid="reason-dialog-textarea"
      />
    </ResidentDialogShell>
  )
}

export function CovidReasonDialog(props: Omit<ReasonDialogProps, 'title'>) {
  return <ReasonDialog {...props} title="COVID Reason" />
}
